var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { key: _vm.versionKey },
    _vm._l(_vm.calendarList, function (cal, i) {
      return _c(
        "div",
        {
          key: cal.id,
          staticClass: "calendar-container",
          class: { "hide-hours": i != 0 },
          style: { width: _vm.width },
        },
        [
          _c("app-full-calendar", {
            ref: "fullCalendar",
            refInFor: true,
            staticClass: "demo-app-calendar",
            style: { flexShrink: 1, flexGrow: 1 },
            attrs: {
              editable: "true",
              "min-time": _vm.minTime || undefined,
              "max-time": _vm.maxTime || undefined,
              "slot-duration": "00:15:00",
              "slot-label-interval": "01:00:00",
              height: "auto",
              "default-view": "timeGridDay",
              "slot-label-format": _vm.timeFormat,
              "time-format": _vm.timeFormat,
              "event-time-format": _vm.timeFormat,
              header: false,
              plugins: _vm.calendarPlugins,
              weekends: true,
              "event-sources": [cal.source],
              views: cal.views,
              "data-calendar-id": cal.id,
            },
            on: {
              dateClick: function ($event) {
                return _vm.handleDateClick($event, cal.id)
              },
              eventClick: function ($event) {
                return _vm.$emit("eventClick", $event)
              },
              eventDrop: function ($event) {
                return _vm.$emit("eventDrop", $event)
              },
              eventDragStart: function ($event) {
                return _vm.$emit("eventDragStart")
              },
              eventDragStop: function ($event) {
                return _vm.onDropStopHandler($event, cal.id)
              },
              eventResize: function ($event) {
                return _vm.$emit("eventResize", $event)
              },
              eventResizeStart: function ($event) {
                return _vm.$emit("eventResizeStart")
              },
              eventResizeStop: function ($event) {
                return _vm.$emit("eventResizeStop")
              },
              eventRender: function ($event) {
                return _vm.state.onEventRender($event)
              },
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }